<script setup lang="ts">
import { useGlobalStore } from "@/store/global";

const globalStore = useGlobalStore();

const props = defineProps({
  journey: {
    type: String,
    required: true
  },
  terminalOneStreamCode: {
    type: String,
    required: true
  }
});

const labels = {
  tableColumns: globalStore.sitecoreData.terminal_specific[props.terminalOneStreamCode].table_columns,
  holds_explanation:
    globalStore.sitecoreData.terminal_specific[props.terminalOneStreamCode].holds_explanation[props.journey],
  holdsExplanationHeading:
    globalStore.sitecoreData.terminal_specific[props.terminalOneStreamCode].holds_explanation.holds_description_heading
};

const columnNames = Object.entries(labels.tableColumns).map(([key, label]) => ({
  id: key,
  label: label,
  noWrap: true,
  sticky: false
}));

const holdsList = Object.values(labels.holds_explanation).map((item: any) => ({
  id: item.id,
  type: item.type,
  description: item.description
}));
</script>

<template>
  <div class="holds_container">
    <div class="holds_container__heading">
      <h3>{{ labels.holdsExplanationHeading }}</h3>
    </div>
    <div class="holds_container__table">
      <mc-table
        :data.prop="holdsList"
        :columns.prop="columnNames"
        fit="medium"
        zebraStripes
        sortdisabled
        verticallinestyle="solid"
      >
      </mc-table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.holds_container {
  margin-top: 40px;
  &__heading {
    color: #3c3c46;
  }
  &__table {
    padding: 40px 5% 20px 5%;
  }
}
</style>
